import { PathBase } from "@constellation-academy/epic-ui";

export class UserEditPath extends PathBase {
	static readonly pathKey = "edit";
}
